const camera_tab_data = [
  {
    id: 0,
    title: "General",
    path: "general",
    dynamicRoute: true,
  },
  {
    id: 1,
    title: "Manual",
    path: "manual",
    dynamicRoute: true,
  },
  {
    id: 2,
    title: "Program",
    path: "program",
    dynamicRoute: true,
  },
  {
    id: 3,
    title: "Stream",
    path: "stream",
    dynamicRoute: true,
  },
  {
    id: 4,
    title: "Settings",
    path: "settings",
    dynamicRoute: true,
  },
  {
    id: 5,
    title: "Chat",
    path: "chat",
    dynamicRoute: true,
  },
];

export default camera_tab_data;
